export const SECTION_LIBRARY_SLUG = 'section-library'

export const INTERNAL_PAGE_SLUGS: ReadonlySet<string> = new Set([SECTION_LIBRARY_SLUG])
